<template>
  <div>
    <div class="z-depth-1 header-row">
      <div class="container">
        <div class="row">
          <div class="col-6 col-sm-3 mb-2 ml-3">
            <a
              href="/savings"
              class="header-logo"
            ><img
              class="img-fluid"
              data-testid="header-image"
              :src="headerLogoSrc"
              :alt="headerLogoAlt"
            ></a>
          </div>
        </div>
      </div>
    </div>

    <!-- hero row -->
    <div class="container mb-1">
      <div class="row hero-row">
        <div class="col-xs-12 col-sm-6 text-center">
          <p class="hero-headline">
            {{ headlineBrands }} to bring you a <strong>better</strong> car payment.
          </p>
          <p class="hero-subheadline">
            Last year we saved our drivers an average of $1,260.
          </p>
          <p class="d-xs-block d-sm-none hero-subheadline2">
            Ready to see how much you could save?
          </p>
          <a
            href="/"
            class="btn btn-apply-now"
            data-testid="apply-now-button"
          >Apply Now</a>
        </div>
        <div class="col-xs-12 col-sm-6 text-center p-0 px-sm-3">
          <img
            class="img-fluid d-none d-sm-block"
            :src="images.desktopdog"
          >
          <img
            class="img-fluid d-xs-block d-sm-none"
            :src="images.refidoautorefinanceredcar"
            style="margin-bottom: -6px;"
          >
        </div>
      </div>
    </div>

    <!-- Reviews row -->
    <div class="text-center review-row mb-4">
      <div class="container">
        <div class="row">
          <div
            v-for="(testimonial, $index) in testimonialList"
            :key="$index"
            class="col-xs-12 col-sm-3"
            :data-testid="`testimonial-${$index}`"
          >
            <div
              v-if="$index > 0"
              class="d-none d-sm-block"
            >
              <i class="material-icons rating-stars">{{ testimonial.rating }}</i>
              <p>"{{ testimonial.quote }}"</p>
              <p>-{{ testimonial.name }}, {{ testimonial.source }}</p>
            </div>
            <div v-else>
              <i class="material-icons rating-stars">{{ testimonial.rating }}</i>
              <p>"{{ testimonial.quote }}"</p>
              <p>-{{ testimonial.name }}, {{ testimonial.source }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- contained content -->
    <div class="container">
      <div class="container reasons-container">
        <p class="text-center reasons-to-refinance">
          Reasons to Refinance Your Car
        </p>
        <ul>
          <li>
            <strong>Reduce your monthly payments:</strong> Refinancing your
            auto loan may reduce your monthly payments by lowering your interest
            rate and/or extending your loan term.
          </li>
          <li>
            <strong>Reduce the total amount of interest you pay on your car
              loan:</strong> Refinancing your auto loan to a lower interest
            rate and/or a shorter term may reduce the total amount of
            interest you pay.
          </li>
        </ul>
        <a
          href="/"
          data-testid="apply-now-link"
        >Apply now to refinance your car</a>
      </div>
    </div>

    <div class="container">
      <p class="text-center font-weight-bold mt-125em connect-with-us">
        Connect with us
      </p>

      <div class="row text-center contact-row">
        <div class="col-12 col-md-4">
          <div
            id="contact-call"
            class="card-panel hoverable contact-panel"
          >
            <div class="mb-2">
              <CallSvg class="svg-icon" />
            </div>
            <p>
              <a
                :href="`tel:${brandPhoneNumber}`"
                data-testid="phone-number-link"
              >{{ brandPhoneNumber }}</a>
            </p>
            <p>Mon. - Fri. 7 am - 7 pm MDT</p>
            <p>Sat. 9 am - 5 pm MDT</p>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div
            id="contact-live-chat"
            class="card-panel hoverable contact-panel"
          >
            <div class="mb-2">
              <ChatSvg class="svg-icon" />
            </div>
            <p>
              <a
                role="button"
                data-testid="live-chat-link"
              >Live Chat</a>
            </p>
            <p>Mon. - Sat. 9 am - 5 pm MDT</p>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div
            id="contact-schedule"
            class="card-panel hoverable contact-panel"
          >
            <div class="mb-2">
              <EmailSvg class="svg-icon" />
            </div>
            <p>
              <a
                :href="`mailto:${brandEmailAddress}`"
                data-testid="email-us-link"
              >Email Us</a>
            </p>
            <p>Have questions?</p>
          </div>
        </div>
      </div>
    </div>

    <div class="applypage-footer text-center">
      <div class="container container-xl">
        <div class="row">
          <div class="col-12">
            <img
              src="https://seal-austin.bbb.org/seals/gray-seal-250-52-whitetxt-bbb-48392.png"
              class="img-fluid mb-2 border-0"
              alt="AUTOPAY BBB Business Review"
            >
            <ul class="bottom-links">
              <li>
                &copy; 2021 POWERED BY AUTOPAY LLC. All rights reserved.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import shuffle from 'lodash/shuffle';

  import desktopdog from 'Images/autopay/desktopdog.png';
  import refidoautorefinanceredcar from 'Images/autopay/refido-auto-refinance-red-car.png';
  import CallSvg from 'Images/autopay/call.svg';
  import ChatSvg from 'Images/autopay/chat.svg';
  import EmailSvg from 'Images/autopay/mail.svg';

  export default {
    components: {
      CallSvg,
      ChatSvg,
      EmailSvg
    },
    data: function () {
      return {
        images: {
          desktopdog,
          refidoautorefinanceredcar
        },
        testimonials: [{
          rating: 'star star star star star',
          quote: 'You guys were great. Quickly saved me tons a month',
          name: 'Mark',
          source: 'Credit Karma'
        }, {
          rating: 'star star star star star',
          quote: 'Very helpful staff. Hassle free transaction. Very Pleased.',
          name: 'Brad',
          source: 'Google'
        }, {
          rating: 'star star star star star',
          quote: 'Amazing fast loan with great rates!!!',
          name: 'Steve',
          source: 'Facebook'
        }, {
          rating: 'star star star star star',
          quote: 'The entire process was very smooth and easy.',
          name: 'John',
          source: 'Facebook'
        }]
      };
    },

    computed: {
      ...mapGetters({
        brandEmailAddress: 'brand/emailAddress',
        brandName: 'brand/name',
        brandPhoneNumber: 'brand/phoneNumber',
        brandFavicon: 'brand/favicon',
        brandStylesheet: 'brand/stylesheet',
        headerLogoSrc: 'brand/headerLogoSrc',
        headerLogoAlt: 'brand/headerLogoAlt',
        isAutopayBrand: 'brand/isAutopayBrand'
      }),

      headlineBrands () {
        return this.isAutopayBrand
          ? 'AUTOPAY is working'
          : `AUTOPAY and ${this.brandName} are working together`;
      },

      testimonialList () {
        return shuffle(this.testimonials);
      }
    },

    metaInfo () {
      const title = (this.brandName || '').includes('AUTOPAY')
        ? this.brandName
        : `AUTOPAY | ${this.brandName}`;

      return {
        link: [
          { rel: 'shortcut icon', href: this.brandFavicon },
          { rel: 'stylesheet', href: 'https://fonts.googleapis.com/icon?family=Material+Icons' },
          { rel: 'stylesheet', href: 'https://fonts.googleapis.com/css?family=Montserrat%3A300%2C400%2C500%2C600%2C700%7CPoppins%3A700' },
          { rel: 'stylesheet', href: '/static/css/bundle.css' }
        ],
        style: [
          { cssText: this.brandStylesheet, type: 'text/css' }
        ],
        title
      };
    }
  };
</script>

<style scoped>
  .svg-icon {
    width: 58px;
    height: 58px;
  }
  .svg-icon .icon-fill-color {
    fill: var(--primary-color);
  }
</style>
